import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DropdownOption } from '@ip-only/front-end-library';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ResourcesService } from '../user/resources.service';
import { UserData } from '../user/user';

@Component({
  selector: 'app-resource-finder',
  templateUrl: './resource-finder.component.html',
  styleUrls: ['./resource-finder.component.scss'],
  standalone: false,
})
export class ResourceFinderComponent implements OnInit, OnDestroy {
  @Input() portalUser: UserData | null;

  constructor(private resourcesService: ResourcesService) {}

  resourceOptions$: Observable<DropdownOption[]>;
  selectedDropdownOption: DropdownOption;
  private cancelSub$ = new Subject<void>();
  filterText = '';
  resourcesLoadingState$ = this.resourcesService.getEntitiesLoadingState$();

  ngOnInit() {
    this.resourcesService
      .getSelectedResource$()
      .pipe(takeUntil(this.cancelSub$))
      .subscribe((resource) => {
        if (resource) {
          this.selectedDropdownOption = {
            value: resource.id,
            label: resource.value,
          };
        }
      });

    this.resourceOptions$ = this.resourcesService.getEntities$().pipe(
      map((resources) => {
        return resources
          .map((resource) => ({
            value: resource.id,
            label: resource.value,
          }))
          .sort((a: DropdownOption, b: DropdownOption) =>
            a.label > b.label ? 1 : -1,
          );
      }),
    );
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  onSelectionChanged(dropdownOption: DropdownOption) {
    this.resourcesService.setSelectedResource(<string>dropdownOption.value);
  }
}
